import { AxiosRequestConfig } from "axios";
import { getInstance } from "../../core/axios-gateway";
import { TTranslate, TTranslateCreateRequest, TTranslateUpdateRequest, TTranslateQuery } from "../../types/translate";

const BASE_PATH = "/api/translates";

export const getTranslates = async (
  params?: TTranslateQuery,
  config?: AxiosRequestConfig
) => {
  return getInstance()
    .get<TTranslate[]>(BASE_PATH, { params, ...config })
    .then((res) => res.data);
};

export const createTranslate = async (
  data: TTranslateCreateRequest,
  config?: AxiosRequestConfig
) => {
  return getInstance()
    .post<TTranslate>(BASE_PATH, data, config)
    .then((res) => res.data);
};

export const updateTranslate = async (
  translateId: string,
  data: TTranslateUpdateRequest,
  config?: AxiosRequestConfig
) => {
  return getInstance()
    .put<TTranslate>(`${BASE_PATH}/${translateId}`, data, config)
    .then((res) => res.data);
};


